<template>
  <modal
    title="Conversion Setting"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <div>
        <label class="label">{{ heading }}:</label>
        <el-select
          v-model="selectedOption"
          placeholder="Select"
          @change="saveCondition(settingType, selectedOption)"
        >
          <el-option
            v-for="option in movementOptions"
            :key="option.slug"
            :label="option.description"
            :value="option.slug"
          >
          </el-option>
        </el-select>
      </div>
      <div class="conditions-wrapper my-2">
        <div class="flex flex-wrap" v-if="updatedPipelineSettings[settingType]">
          <div
            v-for="(condition, index) in updatedPipelineSettings[settingType]
              .conditions"
            :key="index"
            class="condition flex"
          >
            <p>{{ condition.description }}</p>
            <span
              class="cursor-pointer pl-4"
              @click="removeCondition(settingType, condition)"
            >
              X</span
            >
          </div>
        </div>
      </div>

      <p
        class="font-semibold text-darkBlue cursor-pointer mt-2"
        @click="clearAll"
      >
        Clear All
      </p>
      <hr class="my-2" />

      <div class="flex justify-between">
        <p class="cursor-pointer font-semibold" @click="closeModal">Cancel</p>
        <base-button
          text="Save"
          p="py-1 px-6"
          :loading="loading"
          @click="updateSettings"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },

    pipelineSettings: {
      type: Object,
      required: true,
    },
    settingType: {
      type: String,
      required: true,
      default: "leadToOpportunity",
    },
  },
  data() {
    return {
      loading: false,
      movementOptions: [],
      updatedPipelineSettings: {},
      selectedOption: "",
    };
  },

  computed: {
    heading() {
      return this.settingType == "leadToOpportunity"
        ? "Lead to Opportunity"
        : this.settingType == "leadToSale"
        ? "Lead to Sale"
        : "Opportunity to sale";
    },
  },
  mounted() {
    this.getMovementOptions();
    this.updatedPipelineSettings = {
      leadToOpportunity: {
        ...this.pipelineSettings.leadToOpportunity,
        conditions: [...this.pipelineSettings.leadToOpportunity.conditions],
      },
      leadToSale: {
        ...this.pipelineSettings.leadToSale,
        conditions: [...this.pipelineSettings.leadToSale.conditions],
      },
      opportunityToSale: {
        ...this.pipelineSettings.opportunityToSale,
        conditions: [...this.pipelineSettings.opportunityToSale.conditions],
      },
    };
    console.log(this.updatedPipelineSettings == this.pipelineSettings);
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async getMovementOptions() {
      try {
        const response = await this.$_getMovementOptions();
        this.logResponse(response);
        this.movementOptions = response.data.options;
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateSettings() {
      this.loading = true;
      const orgId = localStorage.getItem("organizationId");
      let payload = {
        userInfo: {
          orgId: orgId,
          outletId: null,
          creatorId: orgId,
        },
        payload: {
          setting: {
            ...this.updatedPipelineSettings,
          },
        },
      };
      try {
        const response = await this.$_updatePipelineSettings(payload);
        this.logResponse(response);
        this.generateToast("Settings updated successfully!", "success");
        this.closeModal();
        this.$emit("updated");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    saveCondition(property, selectedSlug) {
      let selectedOption = this.movementOptions.filter((option) => {
        return option.slug == selectedSlug;
      });

      if (
        this.updatedPipelineSettings[property].conditions.indexOf(
          selectedOption[0]
        ) >= 0
      ) {
        // clears selected value
        this.selectedOption = "";
        return;
      }
      this.updatedPipelineSettings[property].conditions.push(selectedOption[0]);
      // clear selected value
      this.selectedOption = "";
    },
    removeCondition(property, condition) {
      let conditionIndex = this.updatedPipelineSettings[
        property
      ].conditions.indexOf(condition);
      this.updatedPipelineSettings[property].conditions.splice(
        conditionIndex,
        1
      );
    },
    clearAll() {
      this.updatedPipelineSettings[this.settingType].conditions = [];
    },
  },
};
</script>

<style scoped>
.condition {
  background: #f2f7fc;
  border: 0.5px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 0.35rem 0.5rem;
  margin: 0.2rem 1rem 0.2rem 0;
  font-size: 0.8rem;
  font-weight: 600;
}
.conditions-wrapper {
  background: #f3f6f9;
  border-radius: 5px;
  padding: 1rem 0.5rem;
}
</style>
